import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showLoading: false,
  showLoginModal: false,
};

export const slice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    setShowLoading: (state, action) => {
      state.showLoading = action.payload.showLoading;
    },
    setShowLoginModal: (state, action) => {
      state.showLoginModal = action.payload.showLoginModal;
    },
  },
});

export const { setShowLoading, setShowLoginModal } = slice.actions;

export default slice.reducer;
